@if (!isRegistrationPage) {
    <mat-card>
        <ng-container *ngTemplateOutlet="page"></ng-container>
    </mat-card>
} @else {
    <ng-container *ngTemplateOutlet="page"></ng-container>
}

<ng-template #page>
    @if (showHeader) {
        <div class="header">
            <div class="text-center">
                <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto logoBg">
            </div>
            <div class="text-center">
                <h3>Welcome to {{ companyName }} community</h3>
            </div>
        </div>
    }
    <div class="content">
        <form [formGroup]="eligibilityForm" class="mt-10 rowTwo mb-10">
            @for (field of this.dynamicFormFields; track field.id) {
                @if (!field.hidden) {
                    <div class="flex-col">
                        <b class="labelTitle">{{ field.text }}</b>
                        @if (field.image) {
                            <div>
                                <img [src]="field.image" class="max-w-100">
                            </div>
                        }
                        @if (field.question_type !== 'date') {
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label></mat-label>
                                @if (field.question_type == 'single_choice' || field.question_type == 'multiple_choice') {
                                    <mat-select (selectionChange)="fieldSelect($event, field)"
                                                [formControlName]="field.id"
                                                [multiple]="field.question_type == 'multiple_choice'">
                                        @for (option of field.options; track option.id) {
                                            <mat-option [value]="option.id">{{ option.text }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                } @else if (field.question_type == 'text') {
                                    <input [formControlName]="field.id" matInput type="text">
                                } @else if (field.question_type == 'domain_check') {
                                    <input [formControlName]="field.id" matInput type="email">
                                }

                                @if (eligibilityForm.controls[field.id].hasError('required')) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                } @else if (eligibilityForm.controls[field.id].hasError('email')) {
                                    <mat-error>
                                        Please enter a valid email address
                                    </mat-error>
                                }
                                @if (field.help_text) {
                                    <mat-hint>{{ field.help_text }}</mat-hint>
                                }
                            </mat-form-field>
                        } @else {
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label></mat-label>
                                <input [formControlName]="field.id" [matDatepicker]="picker"
                                       [max]="field.is_dob? today : null" matInput>
                                <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                @if (eligibilityForm.controls[field.id].hasError('required')) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                }
                                <mat-hint>{{ field.help_text }}</mat-hint>
                            </mat-form-field>
                        }
                    </div>
                }
            }
        </form>
        <div class="w-100 text-center mt-20">
            <button (click)="checkEligibility()"
                    [disabled]="loading || eligibilityForm.invalid" class="mx-auto"
                    color="accent" mat-flat-button>
                Check eligibility
                @if (loading) {
                    <mat-icon>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                }
            </button>
        </div>
    </div>

</ng-template>
